import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { OnboardingState } from '../config/state.model';
import { AuthService } from './auth.service';
import { buildRowPayload } from './payload-builder';

export interface InfrastructureProvider {
  id: number;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class TechMapInfrastructuresApiService {
  private http = inject(HttpClient);
  private auth = inject(AuthService);

  private headers(token: string): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json', Authorization: `JWT ${token}` });
  }

  /** Master infrastructure providers — feeds the provider dropdown on the import screen. */
  async fetchProviders(baseUrl: string): Promise<InfrastructureProvider[]> {
    const { token } = await this.auth.ensureAuth();
    return firstValueFrom(
      this.http.get<InfrastructureProvider[]>(
        `${baseUrl}/master/infrastructures/providers/`,
        { headers: this.headers(token) }
      )
    );
  }

  async submit(state: OnboardingState, baseUrl: string, providerId?: number | null): Promise<void> {
    const { token } = await this.auth.ensureAuth();
    const payload = state.rows
      .map(row => buildRowPayload(state, row))
      .filter(r => !!r['infrastructure_name'])
      // The provider is picked once for the whole import; the BE resolves this
      // id against the master infrastructure provider table per row.
      .map(r => (providerId != null ? { ...r, provider: String(providerId) } : r));
    await firstValueFrom(
      this.http.post<any>(`${baseUrl}/master/infrastructures/bulk-import/`, payload, { headers: this.headers(token) })
    );
  }
}
